/* @flow */

export {InfoBanner} from './info-banner';
